const BigNightInCopy = {

    copy1: `<p>Sign up to hear more about BBC Children in Need and Comic Relief's work.
              You'll hear from each charity about what they do and will be subject to each charity's privacy policy.</p>
              <p>How would you like to hear from Children in Need and Comic Relief?</p>`,
  
    copy2: `<p> You can update your communication preferences with either charity at any time. </p>
              <p> For Comic Relief go to <a
                  href="https://www.comicrelief.com/update-your-preferences"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link inline"
              >comicrelief.com/update-your-preferences</a> - your details will be kept safe, check out our 
  
               <a
                  href="https://www.comicrelief.com/privacy-notice"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link inline"
              >privacy policy</a> for more details.
              
              <p> For BBC Children in Need please see the ‘unsubscribe’ link in emails, 
              the marketing text for details of how to stop text marketing from us or see the details we include in each letter. 
              You can also contact us at any time using the details here and let us know exactly what you would like us to change. 
              Your details will be kept safe, check out our 
              <a
                  href="https://www.bbcchildreninneed.co.uk/legal/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link inline"
              >privacy policy</a> for more details. </p>`,
  };
  
  export default BigNightInCopy;
